import { Skeleton } from '../ui/skeleton';
import { Sparkline } from './Sparkline';

const formatValue = (value, format) => {
  if (value === null || value === undefined) return '—';
  switch (format) {
    case 'percent': return `${typeof value === 'number' ? value.toFixed(1) : value}%`;
    case 'duration': return `${Math.floor((value || 0) / 60)}m ${Math.round((value || 0) % 60)}s`;
    case 'currency': return `$${typeof value === 'number' ? value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : value}`;
    default: return typeof value === 'number' ? value.toLocaleString() : (value || '—');
  }
};

export function KpiCard({
  label,
  value,
  delta,
  deltaLabel = 'vs prev period',
  format = 'number',
  icon: Icon,
  iconColor = 'text-indigo-500',
  iconBg = 'bg-indigo-50 dark:bg-indigo-900/30',
  sparklineData,
  sparklineColor = '#6366f1',
  loading = false,
  onClick,
}) {
  const isPositive = delta > 0;
  const isNeutral = delta === 0 || delta === undefined || delta === null;
  const isBounce = label?.toLowerCase().includes('bounce');
  const isGood = isBounce ? !isPositive : isPositive;

  if (loading) {
    return (
      <div className="p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 space-y-3">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-8 w-24" />
        <Skeleton className="h-3 w-16" />
      </div>
    );
  }

  return (
    <div
      className={`p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 space-y-2 ${onClick ? 'cursor-pointer hover:border-indigo-300 dark:hover:border-indigo-700 transition-colors' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <p className="text-xs text-slate-500">{label}</p>
        {Icon && (
          <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${iconBg}`}>
            <Icon className={`w-3.5 h-3.5 ${iconColor}`} />
          </div>
        )}
      </div>
      <p className="text-2xl font-bold font-heading leading-none">{formatValue(value, format)}</p>
      {!isNeutral && delta !== undefined && (
        <p className={`text-xs ${isGood ? 'text-emerald-600' : 'text-red-500'}`}>
          {isPositive ? '+' : ''}{delta}% {deltaLabel}
        </p>
      )}
      {sparklineData && sparklineData.length >= 2 && (
        <div className="pt-1">
          <Sparkline data={sparklineData} color={sparklineColor} height={36} />
        </div>
      )}
    </div>
  );
}
